import type * as OrderConfirmation from '../types/OrderConfirmation'

export default function orderConfirmationComponentParser(
  rawComponent: OrderConfirmation.Raw,
): OrderConfirmation.Parsed {
  const props = rawComponent.orderConfirmation

  return {
    name: 'OrderConfirmation',
    props,
  }
}
